import { SUPPORT_PHONE, SUPPORT_PHONE_TEL_HREF } from "@rmh/defs";
import { useTranslations } from "next-intl";
import { Divider, Link, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface OnboardingSupportFormFooterProps {
  /** Optional content rendered above the support prompt, e.g. a submit button. */
  children?: ReactNode;
}

export const OnboardingSupportFormFooter = ({
  children,
}: OnboardingSupportFormFooterProps) => {
  const t = useTranslations("onboardingV2");

  return (
    <>
      {children}
      <Divider />
      <Stack
        direction="row"
        sx={{
          paddingX: 6,
          paddingTop: 6,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="bodyMdRegular"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          {t.rich("footer.supportPrompt", {
            phone: SUPPORT_PHONE,
            hyperlink: (chunks) => (
              <Link href={SUPPORT_PHONE_TEL_HREF} underline="hover">
                {chunks}
              </Link>
            ),
          })}
        </Typography>
      </Stack>
    </>
  );
};
